import React, { useEffect, useState } from "react";
import "./Seeyou.css";

function Seeyou() {
  // State for the countdown timer
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  // Calculate time left until the wedding date
  useEffect(() => {
    const weddingDate = new Date("April 5, 2025 00:00:00").getTime();

    const timer = setInterval(() => {
      const now = new Date().getTime();
      const distance = weddingDate - now;

      if (distance < 0) {
        clearInterval(timer);
        return;
      }

      setTimeLeft({
        days: Math.floor(distance / (1000 * 60 * 60 * 24)),
        hours: Math.floor(
          (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        ),
        minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
        seconds: Math.floor((distance % (1000 * 60)) / 1000),
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  // Generate random floating hearts
  const renderFloatingHearts = () => {
    const hearts = [];
    const heartSymbols = ["❤️", "💕", "💖", "💘", "💗"];

    for (let i = 0; i < 20; i++) {
      const size = Math.floor(Math.random() * 20) + 10;
      const symbol =
        heartSymbols[Math.floor(Math.random() * heartSymbols.length)];

      hearts.push(
        <div
          key={i}
          className="floating-heart"
          style={{
            left: `${Math.random() * 100}%`,
            animationDuration: `${Math.random() * 15 + 10}s`,
            animationDelay: `${Math.random() * 5}s`,
            fontSize: `${size}px`,
          }}
        >
          {symbol}
        </div>
      );
    }

    return hearts;
  };

  return (
    <div id="wedding-seeyou" className="wedding-seeyou wedding-section-padding">
      <div className="heart-background">{renderFloatingHearts()}</div>

      <div className="glowing-overlay"></div>

      <div className="wedding-container">
        <div className="wedding-row">
          <div className="wedding-section-head">
            <div className="heart-icon-wrapper">
              <span className="heart-icon pulse-heart">❤️</span>
            </div>

            <h4 className="wedding-subtitle">Hẹn gặp mọi người vào lúc!</h4>

            <div className="wedding-date-display">
              <h3 className="wedding-date">05.04.2025</h3>
              <div className="wedding-divider">
                <span className="wedding-divider-heart">💖</span>
              </div>
            </div>

            <div className="wedding-countdown">
              <div className="countdown-item">
                <div className="countdown-value">{timeLeft.days}</div>
                <div className="countdown-label">Ngày</div>
              </div>
              <div className="countdown-item">
                <div className="countdown-value">{timeLeft.hours}</div>
                <div className="countdown-label">Giờ</div>
              </div>
              <div className="countdown-item">
                <div className="countdown-value">{timeLeft.minutes}</div>
                <div className="countdown-label">Phút</div>
              </div>
              <div className="countdown-item">
                <div className="countdown-value">{timeLeft.seconds}</div>
                <div className="countdown-label">Giây</div>
              </div>
            </div>

            <div className="wedding-message">
              <p>
                Chúng tôi rất mong được đón tiếp bạn trong ngày trọng đại của
                chúng tôi!
              </p>
            </div>

            <div className="decorative-hearts">
              <span className="decorative-heart left">💘</span>
              <span className="decorative-heart right">💘</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Seeyou;
